import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const LanguageToggle = () => {
  const [currentLanguage, setCurrentLanguage] = useState('EN');

  useEffect(() => {
    // Check localStorage for saved language preference
    const savedLanguage = localStorage.getItem('creditFixerLanguage');
    if (savedLanguage && (savedLanguage === 'EN' || savedLanguage === 'FR')) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'EN' ? 'FR' : 'EN';
    setCurrentLanguage(newLanguage);
    localStorage.setItem('creditFixerLanguage', newLanguage);
    
    // Trigger language change event for other components to listen to
    window.dispatchEvent(new CustomEvent('languageChange', { 
      detail: { language: newLanguage } 
    }));
  };

  return (
    <div className="fixed top-6 right-6 z-50">
      <button
        onClick={toggleLanguage}
        className="flex items-center space-x-2 bg-white/95 backdrop-blur-sm border border-gray-200 rounded-full px-4 py-2 shadow-card hover:shadow-cta transition-all duration-200 group"
        aria-label={`Switch to ${currentLanguage === 'EN' ? 'French' : 'English'}`}
      >
        <Icon 
          name="Globe" 
          size={16} 
          className="text-gray-600 group-hover:text-primary transition-colors duration-200" 
        />
        <span className="text-sm font-medium text-gray-700 group-hover:text-primary transition-colors duration-200">
          {currentLanguage}
        </span>
        <div className="flex items-center">
          <span className="text-xs text-gray-400 mx-1">|</span>
          <span className="text-xs text-gray-400">
            {currentLanguage === 'EN' ? 'FR' : 'EN'}
          </span>
        </div>
      </button>
    </div>
  );
};

export default LanguageToggle;